import { render, staticRenderFns } from "./MembersBuy.vue?vue&type=template&id=737ad640&scoped=true"
import script from "./MembersBuy.vue?vue&type=script&lang=js"
export * from "./MembersBuy.vue?vue&type=script&lang=js"
import style0 from "./MembersBuy.vue?vue&type=style&index=0&id=737ad640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737ad640",
  null
  
)

export default component.exports